module.exports = __webpack_public_path__ + "img/品質管理1-12.6b49960d.png";